import { orderTypes } from "./webshop.model";

export interface OrdertypeSettings {
  id: orderTypes;
  iconFilename: string;
  locationServicePropertyName: string;
  useYASBasket?: boolean;
  hasTimeSelection: boolean;
}

const browsing: OrdertypeSettings = {
  id: orderTypes.allUnknown,
  iconFilename: "shop-icons.svg#ya-hypersoft-menu",
  locationServicePropertyName: "service_browse",
  hasTimeSelection: false,
};

const pickup: OrdertypeSettings = {
  id: orderTypes.pickup,
  iconFilename: "shop-icons.svg#ya-hypersoft-abholen",
  locationServicePropertyName: "service_pickup",
  hasTimeSelection: true,
};

const delivery: OrdertypeSettings = {
  id: orderTypes.delivery,
  iconFilename: "shop-icons.svg#ya-hypersoft-liefern",
  locationServicePropertyName: "service_delivery",
  hasTimeSelection: true,
};

const orderToTable: OrdertypeSettings = {
  id: orderTypes.inHouse,
  iconFilename: "shop-icons.svg#ya-hypersoft-tisch",
  locationServicePropertyName: "service_inhouse",
  useYASBasket: true,
  hasTimeSelection: false,
};

const retail: OrdertypeSettings = {
  id: orderTypes.retail,
  iconFilename: "shop-icons.svg#ya-hypersoft-retail",
  locationServicePropertyName: "service_retail",
  hasTimeSelection: false,
};

const ticket: OrdertypeSettings = {
  id: orderTypes.ticket,
  iconFilename: "shop-icons.svg#ya-hypersoft-ticketshop",
  locationServicePropertyName: "service_ticket",
  hasTimeSelection: false,
};

const webvoucher: OrdertypeSettings = {
  id: orderTypes.webvoucher,
  iconFilename: "shop-icons.svg#ya-hypersoft-gutschein",
  locationServicePropertyName: "service_webvoucher",
  hasTimeSelection: false,
};

const pickupGroup: OrdertypeSettings = {
  id: orderTypes.pickupGroup,
  iconFilename: "hypersoft-abholen.svg",
  locationServicePropertyName: "service_pickup_group",
  hasTimeSelection: true,
};

const deliveryGroup: OrdertypeSettings = {
  id: orderTypes.deliveryGroup,
  iconFilename: "hypersoft-liefern.svg",
  locationServicePropertyName: "service_delivery_group",
  hasTimeSelection: true,
};

export const ordertypeSettings: OrdertypeSettings[] = [
  browsing,
  pickup,
  delivery,
  orderToTable,
  retail,
  ticket,
  webvoucher,
  pickupGroup,
  deliveryGroup,
];
